import PageWrapper from 'common/components/PageWrapper';
import { useTranslation } from 'react-i18next';
import NotificationSettingTab from 'modules/notification/components/NotificationSettingTab';

export default function NotificationSettingPage(): JSX.Element {
    const { t } = useTranslation('notification');

    const LINKS = [
        {
            name: t('settings.short'),
        },
        {
            name: t('settings'),
            href: '/dashboard/notifications/settings',
        },
    ];

    return (
        <PageWrapper
            titleHead={t('settings')}
            title={t('settings')}
            links={LINKS}
        >
            <NotificationSettingTab />
        </PageWrapper>
    );
}